export class ConferenceWindowService {
  static conferenceWindow: Window | null = null;
  static windowName: string | null = null;
  static readonly blankPageUrl = 'about:blank';
  static readonly windowFeatures = `status=0,menubar=0,width=${window.screen.availWidth},height=${window.screen.availHeight}`;

  static open(url: string, name: string): boolean {
    ConferenceWindowService.windowName = name;
    ConferenceWindowService.conferenceWindow = window.open(
      url,
      name,
      ConferenceWindowService.windowFeatures
    );
    const blocked = ConferenceWindowService.isPopupBlocked;
    if (blocked) {
      // Discard fake Proxy references from popup blocker extensions
      // so isClosed correctly returns true and polling doesn't false-trigger.
      ConferenceWindowService.conferenceWindow = null;
    }
    return !blocked;
  }

  static get isPopupBlocked(): boolean {
    if (!ConferenceWindowService.conferenceWindow) {
      return true;
    }
    try {
      const win = ConferenceWindowService.conferenceWindow;
      if (win.closed || win === window || win.outerHeight === 0) {
        return true;
      }
      // Popup blocker extensions return a Proxy mirroring the parent window.
      // A real popup navigates to the URL we passed, so its location.href
      // will differ from the parent's. A fake proxy returns the parent's href.
      if (win.location.href === window.location.href) {
        return true;
      }
      return false;
    } catch {
      return true;
    }
  }

  static close() {
    if (ConferenceWindowService.windowName) {
      ConferenceWindowService.conferenceWindow =
        window.open('', ConferenceWindowService.windowName) ??
        ConferenceWindowService.conferenceWindow;
    }

    if (!ConferenceWindowService.conferenceWindow) {
      return;
    }

    ConferenceWindowService.conferenceWindow.close();
  }

  static openOrFocus(url: string, name: string): boolean {
    ConferenceWindowService.windowName = name;
    const targetWindow = window.open('', name);

    if (!targetWindow) {
      return false;
    }

    ConferenceWindowService.conferenceWindow = targetWindow;

    const blocked = ConferenceWindowService.isPopupBlocked;
    if (blocked) {
      ConferenceWindowService.conferenceWindow = null;
      return false;
    }

    try {
      if (targetWindow.location.href === ConferenceWindowService.blankPageUrl) {
        targetWindow.location.href = url;
      }
    } catch {
      // Cross-origin windows can still be focused but not inspected.
    }

    targetWindow.focus();
    return true;
  }

  static get isClosed() {
    return (
      !ConferenceWindowService.conferenceWindow ||
      ConferenceWindowService.conferenceWindow.closed
    );
  }

  static closeWithStateCheck = () => {
    if (!ConferenceWindowService.isClosed) {
      ConferenceWindowService.close();
    }
  };
}
